import { createRouter, createWebHistory } from 'vue-router'
import Home from "@/views/components/Home.vue";
import store from "@/store";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/quran-karim',
        name: 'QuranAlkarim',
        component: () => import('@/views/components/QuranAlkarim.vue')
    },
    {
        path: '/read-quran',
        name: 'ReadQuran',
        component: () => import('@/views/components/ReadQuran.vue')
    },
    {
        path: '/videos',
        name: 'Videos',
        component: () => import('@/views/components/Videos.vue'),
    },
    {
        path: '/alrehima-center',
        name: 'AlrehimaCenter',
        component: () => import('@/views/components/AlrehimaCenter.vue')
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: () => import('@/views/components/AboutUs.vue'),
    },
    {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import('@/views/components/ContactUs.vue'),
    },

    {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/components/ProfilePage.vue')

    },
    {
        path: '/admin',
        component: () => import('@/layouts/DashboardLayout.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
        children: [
            {
                path: '',
                name: 'AdminOverview',
                component: () => import('@/views/Dashboard/Admin/AdminOverview.vue')
            },
            {
                path: 'users',
                name: 'AdminUsers',
                component: () => import('@/views/Dashboard/Admin/AdminUsers.vue')
            },
            {
                path: 'audio',
                name: 'AdminAudio',
                component: () => import('@/views/Dashboard/Admin/AdminAudio.vue')
            },
            {
                path: 'content',
                name: 'AdminContent',
                component: () => import('@/views/Dashboard/Admin/AdminContent.vue')
            },
            {
                path: 'articles',
                name: 'AdminArticles',
                component: () => import('@/views/Dashboard/Admin/AdminArticles.vue')
            },
            {
                path: 'fatwas',
                name: 'AdminFatwas',
                component: () => import('@/views/Dashboard/Admin/AdminFatwas.vue')
            },
            {
                path: 'messages',
                name: 'AdminMessages',
                component: () => import('@/views/Dashboard/Admin/AdminMessages.vue')
            },
            {
                path: 'reports',
                name: 'AdminReports',
                component: () => import('@/views/Dashboard/Admin/AdminReports.vue')
            },
            {
                path: 'newsletter',
                name: 'AdminNewsletter',
                component: () => import('@/views/Dashboard/Admin/AdminNewsletter.vue')
            },
            {
                path: 'settings',
                name: 'AdminSettings',
                component: () => import('@/views/Dashboard/Admin/AdminSettings.vue')
            },
            {
                path: 'courses',
                name: 'AdminCourses',
                component: () => import('@/views/Dashboard/Admin/AdminCourses.vue')
            },
            {
                path: 'events',
                name: 'AdminEvents',
                component: () => import('@/views/Dashboard/Admin/AdminEvents.vue')
            },
            {
                path: 'hisn-al-muslim',
                name: 'AdminHisnAlMuslim',
                component: () => import('@/views/Dashboard/Admin/AdminHisnAlMuslim.vue')
            },
            {
                path: 'profile',
                name: 'AdminProfile',
                component: () => import('@/views/components/ProfilePage.vue')
            },
            {
                path: 'search',
                name: 'AdminSearch',
                component: () => import('@/views/Dashboard/SearchResults.vue')
            }
        ]
    },
    {
        path: '/dashboard',
        component: () => import('@/layouts/DashboardLayout.vue'),
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'UserOverview',
                component: () => import('@/views/Dashboard/User/UserOverview.vue')
            },
            {
                path: 'profile',
                name: 'UserProfile',
                component: () => import('@/views/components/ProfilePage.vue')
            },
            {
                path: 'search',
                name: 'UserSearch',
                component: () => import('@/views/Dashboard/SearchResults.vue')
            },
            {
                path: 'settings',
                name: 'UserSettings',
                component: () => import('@/views/Dashboard/User/UserSettings.vue')
            },
            {
                path: 'my-courses',
                name: 'UserCourses',
                component: () => import('@/views/Dashboard/User/UserCourses.vue')
            },
            {
                path: 'notifications',
                name: 'UserNotifications',
                component: () => import('@/views/Dashboard/NotificationsView.vue')
            }
        ]
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: () => import('@/views/ResetPasswordView.vue')
    },
    {
        path: '/fatwa',
        name: 'Fatwa',
        component: () => import('@/views/FatwaView.vue')
    },
    {
        path: '/login',
        name: 'Auth',
        component: () => import('@/views/components/AuthView.vue')
    },
    {
        path: '/hisn-al-muslim',
        name: 'HisnAlMuslim',
        component: () => import('@/views/HisnAlMuslimView.vue')
    },
    {
        path: '/courses',
        name: 'Courses',
        component: () => import('@/views/CoursesView.vue')
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: () => import('@/views/MaintenanceView.vue'),
        props: (route) => ({ message: store.getters['settings/getSettings'].maintenanceMessage })
    },
    {
        path: '/articles',
        name: 'Articles',
        component: () => import('@/views/components/ArticlesView.vue')
    },
    {
        path: '/articles/:id',
        name: 'ArticleDetails',
        component: () => import('@/views/components/ArticleDetailsView.vue')
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('@/views/PrivacyPolicyView.vue')
    },
    {
        path: '/terms-of-use',
        name: 'TermsOfUse',
        component: () => import('@/views/TermsOfUseView.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFoundView.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0, behavior: 'smooth' }
        }
    }
})

// Router Guard
router.beforeEach(async (to, from, next) => {
    // 1. Ensure Settings are loaded
    if (!store.getters['settings/isLoaded']) {
        try {
            await store.dispatch('settings/fetchPublicSettings');
        } catch (e) {
            console.error('Initial settings load failed', e);
        }
    }

    const isAuthenticated = store.getters['auth/isAuthenticated'];
    let user = store.getters['auth/getUser'];

    // 2. If authenticated but user not in store (rare), skip or log
    // In this app, auth module reads from localStorage synchronously, so user should be there.

    const settings = store.getters['settings/getSettings'];
    const maintenanceMode = settings.maintenanceMode === true || settings.maintenanceMode === 'true';
    const isAdmin = user?.role?.toLowerCase() === 'admin';

    // 3. Maintenance Logic
    if (maintenanceMode && !isAdmin && to.name !== 'Maintenance' && !to.path.startsWith('/admin') && !to.path.startsWith('/login')) {
        return next({ name: 'Maintenance' });
    }

    if (!maintenanceMode && to.name === 'Maintenance') {
        return next({ name: 'Home' });
    }

    // 4. Auth requirement
    if (to.meta.requiresAuth && !isAuthenticated) {
        return next('/login');
    }

    // 5. Role requirement
    if (to.meta.roles && isAuthenticated) {
        const userRole = user?.role?.toLowerCase();
        // If meta.roles is an array, check if userRole is in it
        if (Array.isArray(to.meta.roles)) {
            if (!to.meta.roles.includes(userRole) && userRole !== 'admin') {
                return next('/dashboard');
            }
        } else if (to.meta.roles.includes('admin') && userRole !== 'admin') {
            return next('/dashboard');
        }
    }

    // 6. Prevent logged in users from going to auth
    if (to.path === '/login' && isAuthenticated) {
        return next(isAdmin ? '/admin' : '/dashboard');
    }

    next();
});

export default router;
